import { useNavigate } from 'react-router-dom';
import { Search, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import { DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

export default function SearchUpgradePrompt({ onClose }) {
  const navigate = useNavigate();

  return (
    <div className="p-6 sm:p-8">
      <DialogHeader className="text-center sm:text-center space-y-3">
        <div className="mx-auto w-12 h-12 rounded-full bg-violet-100 dark:bg-violet-900/30 flex items-center justify-center">
          <Search className="w-6 h-6 text-violet-600 dark:text-violet-400" />
        </div>
        <DialogTitle>Advanced Search add-on required</DialogTitle>
        <DialogDescription className="max-w-sm mx-auto">
          Search across all spaces and documents with the Advanced Search add-on. Purchase it from
          Pricing to enable this feature.
        </DialogDescription>
      </DialogHeader>
      <div className="flex flex-col sm:flex-row gap-2 justify-center mt-6">
        <Button variant="outline" onClick={onClose}>
          Close
        </Button>
        <Button
          onClick={() => {
            onClose();
            navigate('/dashboard/pricing');
          }}
        >
          <Sparkles className="w-4 h-4 mr-2" />
          View add-ons
        </Button>
      </div>
    </div>
  );
}
